import { getBrowserAndVersion } from '../helpers';
import { EVENT_TYPE } from './Constants';
import JumboClient, { sendTrackingEventsToJumbo } from './JumboClient';

class ZTracking {
  id = '';

  companyId = '';

  flowType = 0;

  browserName = getBrowserAndVersion().browserName;

  browserVersion = getBrowserAndVersion().browserVersion;

  webVersion = '';

  setId = (id = '') => {
    this.id = id;
    JumboClient.setParams({ user_id: id });
  };

  setSessionId = (sessionId = '') => {
    JumboClient.setParams({ session_id: sessionId });
  };

  setCompanyId = (companyId = '') => {
    this.companyId = companyId;
  };

  setFlowType = (flowType = 0) => {
    this.flowType = flowType;
  };

  setBrowserName = (browserName = '') => {
    this.browserName = browserName;
  };

  setBrowserVersion = (browserVersion = '') => {
    this.browserVersion = browserVersion;
  };

  setWebVersion = (webVersion = '') => {
    this.webVersion = webVersion;
  };

  /*
      Payload format
        id: integer
        company_id: integer
        flow_type: FLOW_TYPE
        browser_name: string
        browser_version: string
        web_version: string
        ui_source: string,
        component: string,
        meta_data: json
    */
  recordImpression = (payload = {}) => {
    const newPayload = { ...payload };
    if (this.id) {
      newPayload.id = this.id;
    }
    if (this.companyId) {
      newPayload.company_id = this.companyId;
    }
    if (this.flowType) {
      newPayload.flow_type = this.flowType;
    }
    sendTrackingEventsToJumbo(EVENT_TYPE.IMPRESSION, newPayload);
  };

  recordClick = (payload = {}) => {
    const newPayload = { ...payload };
    if (this.id) {
      newPayload.id = this.id;
    }
    if (this.companyId) {
      newPayload.company_id = this.companyId;
    }
    if (this.flowType) {
      newPayload.flow_type = this.flowType;
    }
    sendTrackingEventsToJumbo(EVENT_TYPE.CLICK, newPayload);
  };

  recordTyping = (payload = {}) => {
    const newPayload = { ...payload };
    if (this.id) {
      newPayload.id = this.id;
    }
    if (this.companyId) {
      newPayload.company_id = this.companyId;
    }
    if (this.flowType) {
      newPayload.flow_type = this.flowType;
    }
    sendTrackingEventsToJumbo(EVENT_TYPE.TYPING, newPayload);
  };

  recordPageLaunch = (payload = {}) => {
    const newPayload = { ...payload };
    if (this.id) {
      newPayload.id = this.id;
    }
    if (this.companyId) {
      newPayload.company_id = this.companyId;
    }
    if (this.flowType) {
      newPayload.flow_type = this.flowType;
    }
    sendTrackingEventsToJumbo(EVENT_TYPE.PAGE_LAUNCH, newPayload);
  };
}

const ZTrackingClient = new ZTracking();

export default ZTrackingClient;
